import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Modal, ModalControls } from '../../../../components/Modal';
import { Button } from '../../../../components/Buttons';
import { HBox, VBox } from '../../../../components/Box';
import { Check, Euro, Times, IsOpen } from '../../../../components/Icon';
import { Card } from '../../../../components/Card';
import { FormField } from '../../../../components/FormFields';
import { Checkbox } from '../../../../components/Checkbox';
import { Input } from '../../../../components/Input';
import { VehiclePropertyLoadable } from '../../components/VehiclePropertyLoadable';
import { toggleNotification } from '../../../Companies/actions';
import { addExtraCostBulk } from '../../actions';
import { selectWork } from '../../../Api/selectors';
import { REQUEST_ADD_EXTRA_COST_BULK, VEHICLE_EXTRA_COST } from '../../constants';
import { formatCurrency } from '../../../../utils/string';
import _ from 'lodash';
import env from '../../../../env';
import { AppClientId } from '../../../Shared/constants';
const Container = styled.div`
  width: 100%;
  .sum {
    font-size: 16px;
    font-weight: 600;
  }
  .vehicle-property-loadable {
    .label {
      margin-right: auto;
      margin-left: 10px;
    }

    .form-controlField {
      margin-bottom: 0;
    }
    .value {
      width: 90px;
    }
    width: 100%;
    padding: 5px;
    border-bottom: 1px solid #ddd;
    .formField {
      width: auto;
      margin: 0;
    }
    input {
      width: 90px;
    }
  }
`;

const STATE = {
  edit: false,
  add: false,
  amount: '',
  isOpen: false,
  costs: [],
  extraCostSum: 0,
};
/* eslint-disable react/prefer-stateless-function */
class AddExtraCostsComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  get vehicle() {
    return this.props.vehicle;
  }

  get costs() {
    let costs = [];
    Object.keys(this.state).map(key => {
      if (key.indexOf('extra_cost') != -1 && this.state[key]) {
        costs.push({ cost: key, amount: this.state[key] });
      }
    });

    return costs;
  }

  addExtraCost(name, amount) {
    const val = parseFloat(this.state.amount);
    if (!val) {
      return this.resetExtraCost(name);
    }

    const prevValue = +this.state[name];
    let extraCostSum = this.state.extraCostSum + val;
    if (!Number.isNaN(prevValue)) {
      extraCostSum -= prevValue;
    }

    this.setState({ add: null, [name]: val.toFixed(2), extraCostSum });
  }

  resetExtraCost(name) {
    const amountValue = +this.state[name];
    let extraCostSum = this.state.extraCostSum;
    if (!Number.isNaN(amountValue)) {
      extraCostSum -= amountValue;
    }

    this.setState({ [name]: undefined, extraCostSum, add: null });
  }

  openCostField(name, value) {
    this.setState({
      add: name,
      amount: this.state[name] || value,
    });
  }

  onConfirm() {
    const dto = {
      ids: this.props.vehicleIds,
      costs: this.costs,
    };

    this.props.addExtraCostBulk(dto, result => {
      if (result?.success) {
        this.props.toggleNotification('success');

        this.props.onClose();
      }
    });
  }

  render() {
    return (
      <Container>
        <Card className="vehicle-info-card info-card data">
          <HBox>
            {env.clientId === AppClientId.AUTOWIENTJES ? (
              <h2>{this.lbl('vehicle.property.extra_cost_btw')}</h2>
            ) : (
              <h2>{this.lbl('vehicle.property.extra_cost')}</h2>
            )}

            {window.innerWidth <= 768 && (
              <div onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
                {' '}
                <IsOpen />
              </div>
            )}
          </HBox>
          {this.renderEdit()}
        </Card>
      </Container>
    );
  }

  renderEdit() {
    console.dir(VEHICLE_EXTRA_COST);
       
const titles = VEHICLE_EXTRA_COST.filter(item => item.name === 'extra_cost_title_1' || item.name === 'extra_cost_title2');  
const otherItems = VEHICLE_EXTRA_COST.filter(item => item.name !== 'extra_cost_title_1' && item.name !== 'extra_cost_title2');  
  
    return (
      <Modal onClose={this.props.onClose} title={this.props.title}>
        <VBox>
          <VehiclePropertyLoadable name={'extra_cost_sum'}>
            <HBox vCenter left className="sum">
              <div>{this.lbl('vehicle.property.extra_cost_sum')}</div>
              <div className="value" style={{ marginLeft: 'auto' }}>
                {formatCurrency(this.state.extraCostSum || 0)}
              </div>
            </HBox>
          </VehiclePropertyLoadable>

{titles.map(title => (  
  <h2 key={title.name}>{title.name.replace('extra_cost_', '').replace(/_/g, ' ').toUpperCase()}</h2>  
))}  
  
{otherItems.map(item => (  
  <VehiclePropertyLoadable key={item.name} name={item.name}>  
    {this.state.add == item.name ? (  
      <HBox vCenter left>  
        <div className="label">{this.lbl(`vehicle.property.${item.name}`)} </div>  
        <FormField>  
          <Input  
            number  
            onChange={this.onInputChange.bind(this)}  
            small  
            leftDecoration={  
              <>  
                <Euro />  
              </>  
            }  
            name="amount"  
            value={this.state.amount}  
          />  
        </FormField>  
        <Button small onClick={() => this.addExtraCost(item.name, this.state.amount)}>  
          <Check />  
        </Button>  
        <Button warning small onClick={() => this.resetExtraCost(item?.name)}>  
          <Times />  
        </Button>  
      </HBox>  
    ) : (  
      <HBox vCenter>  
        <HBox vCenter onClick={() => this.openCostField(item.name, item.value || '1.00')}>  
          <Checkbox checked={this.state[item?.name]} onChange={() => {}} />  
          <div className="label">{this.lbl(`vehicle.property.${item.name}`)}</div>  
        </HBox>  
        {this.state[item?.name] ? (  
          <div className="value">€ {parseFloat(this.state[item?.name])?.toFixed(2)}</div>  
        ) : null}  
      </HBox>  
    )}  
  </VehiclePropertyLoadable>  
))}  
        </VBox>
        <ModalControls>
          <Button disabled={this.props.work || !!this.state.add} onClick={this.onConfirm.bind(this)}>
            {this.lbl('ok')}
          </Button>
          <Button disabled={this.props.work} onClick={this.props.onClose}>
            {this.lbl('cancel')}
          </Button>
        </ModalControls>
      </Modal>
    );
  }
}

AddExtraCostsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_ADD_EXTRA_COST_BULK),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    addExtraCostBulk(dto, callback) {
      dispatch(addExtraCostBulk(dto, callback));
    },
    toggleNotification(message) {
      dispatch(toggleNotification('1', message));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const AddExtraCosts = compose(withConnect, withRouter)(AddExtraCostsComp);
